const lockAttribute = "data-nexra-scroll-locked";

function lockCount(root: HTMLElement) {
  const count = Number.parseInt(root.getAttribute(lockAttribute) ?? "0", 10);
  return Number.isFinite(count) ? count : 0;
}

/** Share document scroll ownership across nested native dialogs. */
export function lockDocumentScroll() {
  const root = document.documentElement;
  root.setAttribute(lockAttribute, String(lockCount(root) + 1));
  let released = false;

  return () => {
    if (released) return;
    released = true;
    const next = lockCount(root) - 1;
    if (next > 0) root.setAttribute(lockAttribute, String(next));
    else root.removeAttribute(lockAttribute);
  };
}
